var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getQueryParameter } from "flavr-common";
let iceServersPromise;
let iceServersExpiration;
let iceServersRequestPending = false;
const USING_TURN = getQueryParameter(window.location.href, "turn") !== "0";
const FALLBACK_STUN_SERVERS = [{ urls: "stun:stun1.l.google.com:19302" }, { urls: "stun:stun2.l.google.com:19302" }];
export function fetchWebRTCStunTurnServers() {
    return __awaiter(this, arguments, void 0, function* (force = false) {
        if (!force && iceServersPromise) {
            const now = Date.now();
            if (iceServersRequestPending || (iceServersExpiration !== undefined && now <= iceServersExpiration)) {
                return yield iceServersPromise;
            }
        }
        const request = (() => __awaiter(this, void 0, void 0, function* () {
            const iceServers = [];
            try {
                const result = yield fetch("/api/stuns");
                if (!result.ok) {
                    console.warn(`[multiplayer] Failed to fetch ICE servers: ${result.status} ${result.statusText}`);
                    iceServersExpiration = undefined;
                    return [...FALLBACK_STUN_SERVERS];
                }
                const data = yield result.json();
                if (data.stunServers) {
                    for (const stun of data.stunServers) {
                        iceServers.push({
                            urls: `stun:${stun.url}`
                        });
                    }
                }
                if (data.turnServers && USING_TURN) {
                    for (const turn of data.turnServers) {
                        iceServers.push({
                            urls: `turns:${turn.url}`, // ?transport=tcp // force tcp
                            username: turn.username,
                            credential: turn.credential
                        });
                    }
                }
                // WebRTC: Using more than two STUN/TURN servers slows down discovery
                // iceServers.push({ urls: "stun:stun.l.google.com:19302" });
                // iceServers.push({ urls: "stun:stun1.l.google.com:19302" });
                // iceServers.push({ urls: "stun:stun2.l.google.com:19302" });
                const expiration = new Date();
                expiration.setDate(expiration.getDate() + 1);
                iceServersExpiration = expiration.getTime();
            }
            catch (error) {
                console.error("[multiplayer]", error);
                iceServersExpiration = undefined;
                if (iceServers.length === 0) {
                    iceServers.push(...FALLBACK_STUN_SERVERS);
                }
            }
            return iceServers;
        }))();
        iceServersPromise = request;
        iceServersRequestPending = true;
        try {
            return yield request;
        }
        finally {
            if (iceServersPromise === request) {
                iceServersRequestPending = false;
            }
        }
    });
}
export function setVideoTrackContentHint(videoTrack, hint) {
    if (!("contentHint" in videoTrack)) {
        return;
    }
    ;
    videoTrack.contentHint = hint;
    if (videoTrack.contentHint !== hint) {
        console.log(`[multiplayer] Invalid video track contentHint: ${hint}`);
    }
}
